import Swal from 'sweetalert2'

if ($("body.page-template-contact").length) {

    //Autre Question 4
    $('#contactform select[name=contact_entity]').change(function() {
        let input = $('#contact_entity_other')
        // console.log($(this).val())
        if ($(this).val() != "") {
            input.parent().show()
            input.attr('required', '')
        } else {
            input.parent().hide()
            input.removeAttr('required')
            input.val('')
        }
    })

    $("#contactform button").click(function(e) {
        e.preventDefault();
        let form = $(this).parents('#contactform');
        jqueryValidation(form);
        var data = (form.valid()) ? getFormLabelValue(form) : null;
        if (data == null) {
            form.find('input.error, select.error, textarea.error').eq(0).focus()
            form.valid()
            return
        }
        $.ajax({
            type: "POST",
            url: resturl+"formcontact",
            data: $('#contactform').serialize(),
            // headers: {
            //     "Content-Type": "application/json",
            //     "Accept": "application/json",
            // },
        }).done(function(data) {
            Swal.fire(
                'Merci !',
                "Votre demande a bien été envoyée.",
                'success'
            )
        }).fail(function(jqXHR, textStatus, errorThrown) {
            switch(jqXHR.status) {
                default:
                    Swal.fire('Erreur !', "Une erreur inconnue vient de se produire.", 'error');
            }
        })
    });
}


function getFormLabelValue(form) {
    var result = [];
    form.find('input,select').each(function() {
        let id = $(this).attr('id');
        result.push({
            label: $("[for="+id+"]").html(),
            value: $(this).val()
        });
    });
    return result;
}

function jqueryValidation(container) {
    return container.validate({
        focusCleanup: true,
        rules: {
            contact_phone: { phone: true },
        },
        // highlight: (inputElement, errorClass, validClass) => {
        //     $(inputElement).parent().find('label').attr(errorClass, errorClass);
        //     $(inputElement).focus();
        // },
        // unhighlight: (inputElement, errorClass, validClass) => {
        //     $(inputElement).parent().find('label').removeAttr(errorClass);
        // }
    })
}
